// extracted by mini-css-extract-plugin
module.exports = {"AnswersList":"_1RCrZXa1syAKsZVj_DzBYq"};